import './index.less'

import api, { AppPage } from 'api'
import React, { Fragment, useEffect, useState } from 'react'

import { AppPageLayoutDesigerContext } from './AppPageLayoutDesigerContext'
import { AppPageLayoutHeardDesiger } from './AppPageLayoutHeardDesiger'
import { AppPageLayoutBodyDesiger } from './AppPageLayoutBodyDesiger'
import { GetQueryString } from 'utils'

export default function AppPageLayoutDesiger() {
	const [view, setView] = useState('页面布局')
	const [currSelectd, setCurrSelected] = useState({ type: 'component', field: '0' })
	const [appPage, setAppPage] = useState({} as AppPage)
	const loadMetaData = async () => {
		let id = GetQueryString('id')
		if (!id || id === null) {
			id = '0'
		}
		let res = await api.modeling.apppage.getOneDesiger({
			id: Number(id),
			application: GetQueryString('application'),
		})
		setAppPage(res)
	}
	useEffect(() => {
		loadMetaData()
	}, [])
	const chgView = (v: string) => {
		setView(v)
	}
	return (
		<Fragment>
			{JSON.stringify(appPage) === '{}' ? (
				''
			) : (
				<Fragment>
					<AppPageLayoutDesigerContext.Provider
						value={{
							view,
							chgView,
							currSelectd,
							setCurrSelected,
							appPage,
							setAppPage,
						}}
					>
						<div className="app-page-layout-desiger">
							<AppPageLayoutHeardDesiger />
							<AppPageLayoutBodyDesiger />
						</div>
					</AppPageLayoutDesigerContext.Provider>
				</Fragment>
			)}
		</Fragment>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppPageLayoutDesiger/AppPageLayoutDesiger.tsx